<template>
  <div class="page">
    <div id="pdfContent1" class="pdf-box">
      <div>
        <div class="con-box">
          <MainTitle title="体能发育对比" tag="综合能力均分" />
          <div class="clearfix">
            <MiniTable
              class="table"
              :main-data="frirstChartData"
              title-color="#fff"
              head-bg="#F87A52"
              head-border-color="#F87A52"
            />
            <MiniTable
              v-for="(item, index) in mainArr"
              :key="index"
              class="table"
              :main-data="item"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  groupCompareSynthEZAvgScore,
  getClassList
} from '@/api/teachingProtection/assessment'
import MainTitle from './MainTitle.vue'
import MiniTable from './MiniTable.vue'

export default {
  components: {
    MiniTable,
    MainTitle
  },
  props: {
    data: {},
    searchParams: {}
  },
  data() {
    return {
      frirstChartData: {},
      colorList: [],
      classroomName: '',
      sexName: '',
      ageName: '',
      mainArr: [],
      subArr: [],
      barDataArray: []
    }
  },
  created() {
    if (!this.searchParams) return
    let params = this.searchParams
    const classroomNames = []
    const sexNames = []
    const ageNames = []
    getClassList({
      periodType: params.periodType,
      year: params.year,
      semesterType: params.semesterType
    }).then((res) => {
      res.data.array.map((v) => {
        v.classrooms.map((q) => {
          if (params.classroomIds.indexOf(q.id) !== -1) {
            classroomNames.push(q.name)
          }
        })
      })
      this.classroomName = classroomNames.join('、')
    })
    this.$enums.gender.map((v) => {
      if (params.sexes.indexOf(v.code) !== -1) {
        sexNames.push(v.description)
      }
    })
    this.sexName = sexNames.join('、')

    groupCompareSynthEZAvgScore(params).then((res) => {
      res.data.synthEZAvgScore.details.map((item) => {
        item.values.pop()
        item.valueDescs.pop()
      })
      this.frirstChartData = res.data.synthEZAvgScore
      this.barDataArray =
        res.data.barChart.map((item) => {
          item.details.map((_item) => {
            _item.values.pop()
            _item.valueDescs.pop()
          })
          return item
        }) || []
      this.mainArr = this.barDataArray.slice(0, 5)
      this.subArr = this.barDataArray.slice(5, 8)
    })
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
.table {
  float: left;
  width: 360px;
  margin-right: 20px;
  margin-bottom: 20px;
  margin-top: 35px;
}
.pdf-box {
  width: 1200px;
  background: #ffffff;
  // transform: scale(0.9);
  // transform-origin: 0 0 0;
  .con-box {
    padding: 30px;
  }
}
.search-term {
  min-width: 100px;
}
.search-con {
  background: #f0f4f7;
  border-radius: 2px;
  padding: 5px 10px;
  max-width: 600px;
  margin-left: 20px;
  line-height: 20px;
}
.type-box {
  font-size: 12px;
  .name {
    font-weight: 500;
    font-size: 22px;
    color: #333333;
    line-height: 30px;
    text-align: left;
    font-style: normal;
  }
  .val {
    color: #ff6c14;
  }
}
.chart-item {
  float: left;
  width: 360px;
  height: 320px;
  margin-right: 20px;
  margin-bottom: 20px;
}
.tips {
  height: 51px;
  line-height: 51px;
  margin-right: 20px;

  .item {
    float: left;
    margin-right: 20px;
    position: relative;
    padding-left: 20px;
    i {
      position: absolute;
      content: "";
      left: 0px;
      top: 17px;
      height: 15px;
      width: 15px;
    }
  }
}
</style>
